var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',{staticClass:"font-weight-bold",attrs:{"cols":"12","sm":"4"}},[_c('ressource',{attrs:{"code":'info_' + _vm.code}})],1),_c('v-col',{attrs:{"cols":"12","sm":"8"}},[_vm._v(" "+_vm._s(_vm.value)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }